/*
 * @Author: Jun
 * @Date: 2021-03-24 16:48:06
 * @LastEditTime: 2021-03-24 16:50:10
 * @LastEditors: JUN
 * @Description:
 * @FilePath: /guokr-ad/src/views/CC/index.tsx
 */
import { makeStyles, Theme } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Tab from "@material-ui/core/Tab"
import Tabs from "@material-ui/core/Tabs"
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation'
import ListAltIcon from '@material-ui/icons/ListAlt'
import SwipeViews from "react-swipeable-views"
import React, { Fragment, useState, useContext } from "react"
import { AppContext } from "../Home/context"
import Calendar from "Components/Calendar"
import TabPanel from "./TabPanel"
import { BeautyCalendarTab } from "Types/app"
const tabArray: BeautyCalendarTab[] = [
    {
        value: "beauty_board",
        text: "美丽日历",
        icon: <InsertInvitationIcon/>,
    }, {
        value: "beauty_article_type",
        text: "文章类型",
        icon: <ListAltIcon/>,
    },
]
const useStyles = makeStyles((theme: Theme) => ({
    "@global": {
        "#root": {
            display: "flex",
        },
    },
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    tabIndicator: {
        height: 0,
    },
    tabItem: {
        lineHeight: 1,
        marginTop: 4,
        borderRadius: theme.shape.borderRadius,
        fontSize: 14,
        minHeight: 0,
    },
    selectedItem: {
        backgroundColor: "#ff9800",
        color: "white",
        borderWidth: 0,
    },
}))

export default function BeautyCalendar() {
    const classes = useStyles()
    const [ index, setIndex ] = useState(0)

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setIndex(newValue)
    }
    const handleChangeIndex = (index: number) => {
        setIndex(index)
    }
    const { privilegeMap, user } = useContext(AppContext)
    return (
        <div className={classes.root}>
            <Tabs
                value={index}
                onChange={handleChange}
                classes={{
                    indicator: classes.tabIndicator,
                }}
                centered
            >
                {
                    tabArray.map((tab: BeautyCalendarTab, index) => (
                        <Tab
                            label={tab.text}
                            icon={tab.icon}
                            key={tab.value}
                            value={index}
                            classes={{
                                root: classes.tabItem,
                                selected: classes.selectedItem,
                            }}
                        />
                    ))
                }
            </Tabs>
            <SwipeViews
                index={index}
                onChangeIndex={handleChangeIndex}
            >
                {
                    tabArray.map((tab: BeautyCalendarTab, index) => {
                        switch (tab.value) {
                            case 'beauty_board':
                                return (
                                    <Fragment>
                                        <Calendar channelName={'美丽'}/>

                                        <Typography component="div">
                                            <pre style={{whiteSpace: 'pre-line'}}>
                                                {/* 预约规则：<br/>
                                                其他部门同事想预约美丽点位，请联系【姜子琪】。 */}
                                                {/* 果壳童学馆每日推送一次，发布时间 ：早7:30<br/>
                                                1.电商每周固定占周三头条卖货，电商每周最多约3个次条，当约第四个时系统报错；<br/>
                                                2.当电商或商务占住头条点位时，次条自动锁定，不可进行电商或商务预约；当电商或商务占住次条点位时，则头条自动锁定，不可进行电商或商务预约；<br/>
                                                3.电商最多提前两周进行占位；<br/>
                                                4.商务每周不能预约超过2个头条，当约第三个时系统报错；<br/>
                                                5.已预约的3天内的点位不可删除。<br/> */}
                                            </pre>
                                        </Typography>
                                    </Fragment>
                                )

                            default:
                                return (
                                    <TabPanel tab={tab} index={index} key={index} privilegeMap={privilegeMap}/>
                                )
                        }
                    })
                }
            </SwipeViews>
            <div id="board_input_modal" />
            <div id="beauty_article_type_modal" />
        </div>
    )
}
